module.exports = "export default __webpack_public_path__ + &quot;3651f61b34ca6ae322e930de59b3dbc6.svg&quot;;"